<!-- 
  新建页面扫码
  props
    nonEditable: 1 是否可编辑
    slectProBtn: 产品选择按钮状态
    fieldAttr:字段名
    barcodeParams: 请求产品所需参数
  emit
    @getProduct 条码获得，通知到父组件从而获取父组件中请求产品所需参数barcodeParams
    @sendProduct 向父组件发送扫到的并且库中有的产品
-->
<template>
  <div class="scanCode">
    <i 
      :class="{'web-icon-mingpiansaomiao':true, 'gray': slectProBtn, 'blue': !slectProBtn}">
    </i>
    <el-input 
      :disabled="slectProBtn" 
      v-model="barcode" 
      @change="getBarcode" 
      placeholder="扫码录入条码">
    </el-input>
  </div>
</template>

<script>
import * as api from 'src/api'
// import { Message } from 'element-ui'

export default {
  props: {
    barcodeParams: {
      type: Object,
      default: () => {}
    },
    fieldAttr: {
      type: String
    },
    slectProBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      barcodeProduct: [], // 条码产品
      barcode: '' // 条形码
    }
  },
  methods: {

    // 获取条码
    getBarcode (val) {
      if (val) {
        console.log('码', val)
        this.$emit('getProduct', this.fieldAttr)
        this.$nextTick(() => {
          this.getProduct()
        })
      }
    },

    // 用条码获取产品
    getProduct () {
      let url = '/productApi/scanBarcode.html'
      let params = this.barcodeParams
      this.barcodeParams.barcode = this.barcode.trim()
      api.post(url, params, (data) => {
        this.barcodeProduct = data.result[0]
        console.log('条码产品', this.barcodeProduct)
        this.$emit('sendProduct', this.barcodeProduct, this.fieldAttr)
        setTimeout(() => {
          this.barcode = ''
        }, 80)
      }, (errorData) => {
        this.barcode = ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .scanCode {
    display: inline-block;
    padding-left: 10px;
    .blue {
      color: #409eff;
    }
    .gray {
      color: #c0c4cc;
    }
  } 
</style>


// WEBPACK FOOTER //
// scan-code.vue?8a3ab354